export enum DisputeReason {
  LESSON_NOT_GIVEN = "lesson_not_given",
  QUALITY_ISSUE = "quality_issue",
  INSTRUCTOR_ABSENT = "instructor_absent",
  STUDENT_ABSENT = "student_absent",
  OTHER = "other",
}
